// lineSymmetricEndpointTools.js — Sequential 2-click collectors for LINE rules with no
// tip/rear asymmetry (tickets 13–16): LINE4, LINE14, LINE18, LINE19.
// Replaces useMapEditor single-click-and-spread so mil-sym live preview works during draw.

import { DrawRules } from '@armyc2.c5isr.renderer/mil-sym-ts-web';
import Feature from 'ol/Feature';
import { LineString } from 'ol/geom';
import { registerDrawInteraction } from '../customDrawInteractions';
import { createSequentialCollector } from './sequentialCollector';
import { PREVIEW_LINE_BLUE } from './drawPreviewStyles';

function makeSymmetricTwoPoint(map, opts) {
    return createSequentialCollector(map, {
        minCount: 2,
        maxCount: 2,
        onFinish: opts.onFinish,
        sidc: opts.sidc || null,
        previewMinPoints: 1,
        cursorFirst: false,
        applyReorderToPreview: false,
        roleForIndex: (i) => (i === 0 ? 'anchor' : 'direction'),
        styleResolver: () => PREVIEW_LINE_BLUE,
        onSketchUpdate: ({ previewSource, collected3857, cursorCoord3857 }) => {
            const pts = cursorCoord3857 ? [...collected3857, cursorCoord3857] : collected3857;
            if (pts.length >= 2) previewSource.addFeature(new Feature(new LineString(pts)));
        },
    });
}

registerDrawInteraction(DrawRules.LINE4,  (map, opts) => makeSymmetricTwoPoint(map, opts));
registerDrawInteraction(DrawRules.LINE14, (map, opts) => makeSymmetricTwoPoint(map, opts));
registerDrawInteraction(DrawRules.LINE18, (map, opts) => makeSymmetricTwoPoint(map, opts));
registerDrawInteraction(DrawRules.LINE19, (map, opts) => makeSymmetricTwoPoint(map, opts));
